import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { GetIncidentsParams } from './getIncidents'
import { GetThreatDetailParams } from './getIncidentDetails'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiKey } from '../components/enums'

// Get Cove threat listing
export const getCoveThreatLisiting = (params: GetIncidentsParams) => {
  return axios.get(endpoints.getCoveIncidentLisiting, { params })
}

export const UseCoveThreatLisiting = (params: GetIncidentsParams = {}) => {
  return useQuery([ApiKey.CoveLisiting, ApiKey.list, params], () => getCoveThreatLisiting(params))
}

// Get Cove threat details
export const getCoveThreatDetail = async (params: GetThreatDetailParams) => {
  return axios.get(endpoints.coveThreatDetails, { params })
}

export const useCoveThreatDetail = (params: GetThreatDetailParams) => {
  return useQuery([ApiKey.coveThreats, ApiKey.detail, params], () => getCoveThreatDetail(params))
}

// Accept or reject a claim for Cove
export const acceptOrRejectClaimCove = async (data: object) => {
  return axios.post(endpoints.acceptOrRejectClaimCove, data)
}

export const useAcceptOrRejectClaimCove = () => {
  const queryClient = useQueryClient()
  return useMutation(acceptOrRejectClaimCove, {
    onSuccess: () => {
      queryClient.invalidateQueries([ApiKey.CoveLisiting, ApiKey.list])
    },
  })
}
